<template>
  <div class="content" id="d1">
    <div class="main">
      <div class="grade">
        <span id="sel">筛选：</span>
        <span @click="changeSection()" :class="section == false ? 'active' : ''"
          >全部</span
        >
        <span
          @click="changeSection(item.section_id)"
          v-for="item in this.sectionData"
          :key="item.section_id"
          :class="item.section_id == section ? 'active' : ''"
          >{{ item.section_name }}</span
        >
        <div class="block">
          <el-select
            @change="changeYear(2)"
            v-model="term"
            placeholder="全部"
            style="width: 100px"
          >
            <el-option
              v-for="item in this.termData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>

          <el-select
            @change="changeYear(1)"
            v-model="year"
            placeholder="全部"
            style="width: 130px"
          >
            <el-option
              v-for="item in this.yearData"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="nav clearfix top-operation">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            :stretch="true"
            label="全部文章"
            name="article"
            key="article"
          ></el-tab-pane>
          <!-- <el-tab-pane
            :stretch="true"
            label="全部视频"
            name="video"
            key="video"
          ></el-tab-pane> -->
          <el-tab-pane
            :stretch="true"
            :label="item.name"
            :name="item.id.toString()"
            v-for="item in this.typeDataTmp"
            :key="item.id"
          ></el-tab-pane>
        </el-tabs>
      </div>

      <div class="top-operation clearfix line">
        <el-button
          v-if="isVideo && isSelf && identity.identity_status == 1"
          class="el-icon-upload2"
          type="primary"
          size="mini"
          @click="addBtn()"
          >上传视频</el-button
        >
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-document"
          v-if="isVideo == false && isSelf && identity.identity_status == 1"
          @click="addBtn()"
          >写文章</el-button
        >
        <span @click="changeActive(1)" :class="active1">点击数排序</span>
        <span @click="changeActive(0)" :class="active2">时间排序</span>
      </div>

      <!-- 新增文章弹出框 -->
      <el-dialog
        title="新增文章"
        class="add_article_box"
        :closeOnClickModal="false"
        :visible.sync="dialogVisible1"
        width="700px"
        :before-close="close1"
      >
        <p class="p1">
          标题：
          <span style="color: red">*</span>
        </p>
        <p class="p2">
          <el-input
            type="text"
            v-model="title"
            placeholder="请输入标题，20字以内"
            maxlength="20"
            show-word-limit
          ></el-input>
        </p>
        <p class="p1">
          学段：
          <span style="color: red">*</span>
        </p>
        <p class="p3">
          <el-select v-model="section" placeholder="学段">
            <el-option
              v-for="item in sectionData"
              :key="item.section_id"
              :label="item.section_name"
              :value="item.section_id"
            ></el-option>
          </el-select>
        </p>
        <p class="p1">
          类型：
          <span style="color: red">*</span>
        </p>
        <p class="p3">
          <el-select v-model="type" :placeholder="placeholderName">
            <el-option
              v-for="item in typeData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </p>
        <p class="p1">
          模式：
          <span style="color: red">*</span>
        </p>
        <p class="p2">
          <el-radio v-model="mode" @change="changeMode()" label="1"
            >写作</el-radio
          >
          <el-radio v-model="mode" @change="changeMode()" label="2"
            >文档</el-radio
          >
        </p>
        <!-- 上传类型 -->
        <div v-if="mode == 1">
          <p class="p1">
            文章内容：
            <span style="color: red">*</span>
          </p>
          <div class="div1">
            <quill-editor
              class="el-editor"
              ref="myTextEditor"
              v-model="content1"
              :options="quillOption"
            ></quill-editor>
          </div>
        </div>

        <div class="p1" v-if="mode == 2">
          <span class="text">文档上传</span>
          <i class="star">*</i>
          <span class="tips">支持word/ppt/excel/pdf格式，不大于200M</span>
          <uploader
            ref="upload1"
            class="uploader-example"
            :options="options"
            :autoStart="false"
            :file-status-text="statusText"
            @file-success="onFileSuccess"
            @file-added="filesAdded"
            @file-progress="fileProgress"
            @file-error="onFileError"
            @file-removed="fileRemoved"
          >
            <uploader-unsupport></uploader-unsupport>
            <uploader-drop>
              <uploader-btn :single="true" :attrs="attrs1"
                >点击上传</uploader-btn
              >
            </uploader-drop>
            <uploader-list></uploader-list>
          </uploader>
        </div>

        <p class="p1" id="p1">
          权限：
          <span style="color: red">*</span>
        </p>
        <p class="p3">
          <el-radio v-model="open_scope" label="1">公开</el-radio>
          <el-radio v-model="open_scope" label="4">本校</el-radio>
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" :disabled="isDisabled" @click="submitOk1(1)"
            >确定</el-button
          >
          <el-button @click="dialogVisible1 = false">取消</el-button>
        </span>
      </el-dialog>
      <!-- 新增文章弹出框 -->

      <!-- 编辑文章弹出框 -->
      <el-dialog
        title="编辑文章"
        class="add_article_box"
        :closeOnClickModal="false"
        :visible.sync="dialogVisible2"
        :before-close="close2"
        width="700px"
      >
        <p class="p1">
          标题：
          <span style="color: red">*</span>
        </p>
        <p class="p2">
          <el-input
            type="text"
            v-model="title"
            @keydown.native="changeEdit()"
            placeholder="请输入标题，20字以内"
            maxlength="20"
            show-word-limit
          ></el-input>
        </p>
        <p class="p1">
          学段：
          <span style="color: red">*</span>
        </p>
        <p class="p3">
          <el-select
            @change="changeEdit()"
            v-model="section"
            placeholder="学段"
          >
            <el-option
              v-for="item in sectionData"
              :key="item.section_id"
              :label="item.section_name"
              :value="item.section_id"
            ></el-option>
          </el-select>
        </p>
        <p class="p1">
          类型：
          <span style="color: red">*</span>
        </p>
        <p class="p3">
          <el-select
            v-model="type"
            :placeholder="placeholderName"
            @change="changeEdit()"
          >
            <el-option
              v-for="item in typeData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </p>
        <p class="p1">模式</p>
        <p class="p2">
          <el-radio
            v-model="mode"
            @change="changeMode(), changeEdit()"
            label="1"
            >写作</el-radio
          >
          <el-radio
            v-model="mode"
            @change="changeMode(), changeEdit()"
            label="2"
            >文档</el-radio
          >
        </p>

        <!-- 上传类型 -->
        <div v-if="mode == 1">
          <p class="p1">
            文章内容：
            <span style="color: red">*</span>
          </p>
          <div class="div1">
            <quill-editor
              class="el-editor"
              ref="myTextEditor"
              @keydown.native="changeEdit()"
              v-model="content2"
              :options="quillOption"
            ></quill-editor>
          </div>
        </div>

        <div class="p1" v-if="mode == 2">
          <span class="text">文档上传</span>
          <i class="star">*</i>
          <span class="tips">支持word/ppt/excel/pdf格式，不大于200M</span>
          <uploader
            class="uploader-example"
            :options="options"
            :autoStart="false"
            :file-status-text="statusText"
            @file-success="onFileSuccess"
            @file-added="filesAdded"
            @file-progress="fileProgress"
            @file-error="onFileError"
            @file-removed="fileRemoved"
          >
            <uploader-unsupport></uploader-unsupport>
            <uploader-drop>
              <uploader-btn :single="true" :attrs="attrs1"
                >点击上传</uploader-btn
              >
            </uploader-drop>
            <uploader-list v-show="panelShow"></uploader-list>
          </uploader>
          <ul
            class="el-upload-list el-upload-list--text"
            v-show="show_filename && info.filename"
          >
            <li tabindex="0" class="el-upload-list__item is-success">
              <a class="el-upload-list__item-name">
                <i class="el-icon-document"></i>
                {{ info.filename }}
              </a>
            </li>
          </ul>
        </div>

        <p class="p1" id="p1">权限</p>
        <p class="p3">
          <el-radio @change="changeEdit()" v-model="open_scope" label="1"
            >公开</el-radio
          >
          <el-radio @change="changeEdit()" v-model="open_scope" label="4"
            >本校</el-radio
          >
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" :disabled="isDisabled" @click="submitOk1(2)"
            >确定</el-button
          >
          <el-button @click="dialogVisible2 = false">取消</el-button>
        </span>
      </el-dialog>
      <!-- 编辑文章弹出框 -->

      <!-- 新增视频弹出框 -->
      <el-dialog
        title="新增视频"
        class="add_video_box"
        :visible.sync="dialogVisible4"
        :closeOnClickModal="false"
        :before-close="close4"
        width="600px"
      >
        <div class="dialog_content">
          <div class="form_item">
            <div class="title_text">
              视频标题：
              <span style="color: red">*</span>
            </div>
            <el-input
              type="text"
              v-model="title"
              placeholder="请输入视频标题，20字以内"
              maxlength="20"
              show-word-limit
              class="input_item"
            ></el-input>
          </div>

          <div class="form_item">
            <div class="title_text">
              学段：
              <span style="color: red">*</span>
            </div>
            <el-select v-model="section" placeholder="学段">
              <el-option
                v-for="item in sectionData"
                :key="item.section_id"
                :label="item.section_name"
                :value="item.section_id"
              ></el-option>
            </el-select>
          </div>
          <div class="form_item">
            <div class="title_text">
              类型：
              <span style="color: red">*</span>
            </div>
            <el-select v-model="type" placeholder="类型">
              <el-option
                v-for="item in typeData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="form_item">
            <div class="title_text">
              视频文件:
              <span style="color: red">*</span>
              <span class="advice">&nbsp;&nbsp;支持MP4格式，不大于1G</span>
            </div>
            <uploader
              ref="upload2"
              class="uploader-example"
              :options="options"
              :autoStart="false"
              :file-status-text="statusText"
              @file-success="onFileSuccess"
              @file-added="filesAdded"
              @file-progress="fileProgress"
              @file-error="onFileError"
              @file-removed="fileRemoved"
            >
              <uploader-unsupport></uploader-unsupport>
              <uploader-drop>
                <uploader-btn :single="true" :attrs="attrs2"
                  >点击上传</uploader-btn
                >
              </uploader-drop>
              <uploader-list v-show="panelShow"></uploader-list>
            </uploader>
          </div>

          <div class="form_item">
            <div class="title_text">
              视频封面：
              <span class="advice"
                >建议160*100px,支持jpg/png格式，不大于5M</span
              >
            </div>
            <el-upload
              class="avatar-uploader mr-b20"
              list-type="picture-card"
              :action="uploadUrl"
              :data="uploadData"
              :on-success="onSuccess2"
              :before-upload="beforeUpload2"
              :on-progress="onProgress2"
              :on-change="onChange2"
              :on-remove="onRemove2"
              :on-exceed="onExceed"
              :on-preview="handlePictureCardPreview"
              :limit="fileLimit"
              accept=".jpg, .jpeg, .png"
              ref="upload"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" />
            </el-dialog>
          </div>

          <div class="form_item">
            <div class="title_text">视频简介：</div>
            <el-input
              class="input_item video_description"
              type="textarea"
              :rows="4"
              placeholder="请输入视频简介，200以内"
              v-model="content3"
              show-word-limit
              maxlength="200"
            ></el-input>
          </div>

          <div class="form_item">
            <div class="title_text">
              权限：
              <span style="color: red">*</span>
            </div>
            <el-radio v-model="open_scope" label="1">公开</el-radio>
            <el-radio v-model="open_scope" label="4">本校</el-radio>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button :disabled="isDisabled" type="primary" @click="submitOk2(1)"
            >发布</el-button
          >
        </span>
      </el-dialog>
      <!-- 新增视频弹出框 -->

      <!-- 编辑视频弹出框 -->
      <el-dialog
        title="编辑文章"
        class="add_video_box"
        :visible.sync="dialogVisible5"
        :closeOnClickModal="false"
        :before-close="close5"
        width="600px"
      >
        <div class="dialog_content">
          <div class="form_item">
            <div class="title_text">
              视频标题：
              <span style="color: red">*</span>
            </div>
            <el-input
              type="text"
              @keydown.native="changeEdit()"
              v-model="title"
              placeholder="请输入视频标题，20字以内"
              maxlength="20"
              show-word-limit
              class="input_item"
            ></el-input>
          </div>

          <div class="form_item">
            <div class="title_text">
              学段：
              <span style="color: red">*</span>
            </div>
            <el-select
              @change="changeEdit()"
              v-model="section"
              placeholder="学段"
            >
              <el-option
                v-for="item in sectionData"
                :key="item.section_id"
                :label="item.section_name"
                :value="item.section_id"
              ></el-option>
            </el-select>
          </div>
          <div class="form_item">
            <div class="title_text">
              类型：
              <span style="color: red">*</span>
            </div>
            <el-select v-model="type" placeholder="请选择类型">
              <el-option
                v-for="item in typeData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="form_item">
            <div class="title_text">
              视频文件：
              <span style="color: red">*</span>
              <span class="advice">&nbsp;&nbsp;支持MP4格式，不大于1G</span>
            </div>
            <uploader
              class="uploader-example"
              :options="options"
              :autoStart="false"
              :file-status-text="statusText"
              @file-success="onFileSuccess"
              @file-added="filesAdded"
              @file-progress="fileProgress"
              @file-error="onFileError"
              @file-removed="fileRemoved"
            >
              <uploader-unsupport></uploader-unsupport>
              <uploader-drop>
                <uploader-btn :single="true" :attrs="attrs2"
                  >点击上传</uploader-btn
                >
              </uploader-drop>
              <uploader-list v-show="panelShow"></uploader-list>
            </uploader>
            <ul
              class="el-upload-list el-upload-list--text"
              v-show="show_filename"
            >
              <li tabindex="0" class="el-upload-list__item is-success">
                <a class="el-upload-list__item-name">
                  <i class="el-icon-video-play"></i>
                  {{ info.filename }}
                </a>
              </li>
            </ul>
          </div>

          <div class="form_item">
            <div class="title_text">
              视频封面:
              <span class="advice"
                >建议160*100px,支持jpg/png格式，不大于5M</span
              >
            </div>
            <el-upload
              class="avatar-uploader mr-b20"
              list-type="picture-card"
              :action="uploadUrl"
              :data="uploadData"
              :on-success="onSuccess2"
              :before-upload="beforeUpload2"
              :on-progress="onProgress2"
              :on-change="onChange2"
              :on-remove="onRemove2"
              :on-exceed="onExceed"
              :on-preview="handlePictureCardPreview"
              :limit="fileLimit"
              accept=".jpg, .jpeg, .png"
              ref="upload"
            >
              <img
                v-if="imageUrl"
                :src="imageUrl"
                style="height: 146px; width: 146px"
                class="el-upload-list__item-thumbnail"
              />
              <i v-else class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" />
            </el-dialog>
          </div>

          <div class="form_item">
            <div class="title_text">视频简介:</div>
            <el-input
              class="input_item video_description"
              type="textarea"
              :rows="4"
              @keydown.native="changeEdit()"
              placeholder="请输入视频简介，200以内"
              v-model="content4"
              show-word-limit
              maxlength="200"
            ></el-input>
          </div>

          <div class="form_item">
            <div class="title_text">
              权限：
              <span style="color: red">*</span>
            </div>
            <el-radio @change="changeEdit()" v-model="open_scope" label="1"
              >公开</el-radio
            >
            <el-radio @change="changeEdit()" v-model="open_scope" label="4"
              >本校</el-radio
            >
          </div>
        </div>
        <span slot="footer" class="dialog-footer" style="margin-top: 5px">
          <el-button :disabled="isDisabled" type="primary" @click="submitOk2(2)"
            >编辑</el-button
          >
        </span>
      </el-dialog>
      <!-- 编辑视频弹出框 -->

      <!-- 创作列表 -->
      <table :data="articleList" width="1100" v-loading="loading">
        <tr class="first-tr">
          <td class="td1" width="300">标题</td>
          <td width="240">权限</td>
          <td width="120">浏览人数</td>
          <td width="220">时间</td>
          <td width="120" v-if="isSelf">状态</td>
          <td width="320" v-if="isSelf">操作</td>
        </tr>
        <!-- 缺省 -->
        <div v-if="isShow" class="none">
          {{ isVideo ? "暂无视频资源" : "暂无文章" }}
        </div>
        <tr
          class="second-tr"
          v-for="item in this.articleList"
          :key="item.id"
          v-else
        >
          <td class="td-1">
            <p @click="toInfo(item)" :title="item.title" target="_blank">
              {{ item.title }}
            </p>
          </td>
          <td
            class="td-2 limit"
            :title="
              item.open_scope == 1
                ? item.open_scope == 1
                  ? '公开'
                  : '本校'
                : item.school_name + '校内'
            "
          >
            {{
              item.open_scope == 1
                ? item.open_scope == 1
                  ? "公开"
                  : "本校"
                : item.school_name + "校内"
            }}
          </td>
          <td class="td-2">{{ item.view_count }}</td>
          <td class="td-2">{{ item.create_time }}</td>

          <span v-if="item.delete_by != 0 && isSelf">
            <td class="td-2" style="color: #797c81">已屏蔽</td>
          </span>
          <span v-if="item.delete_by == 0 && isSelf">
            <td
              v-if="item.approve_status == 1 && isSelf"
              class="td-2"
              style="color: #f3c22c"
            >
              待审核
            </td>
            <td
              v-if="item.approve_status == 2 && isSelf"
              class="td-2"
              style="color: #33d86d"
            >
              已通过
            </td>
            <td
              v-if="item.approve_status == 3 && isSelf"
              class="td-2"
              style="color: #d83333"
            >
              未通过
            </td>
          </span>

          <td class="td-2 td-3" v-if="isSelf">
            <el-button
              class="el-icon-download"
              style="border: none; background: #f6f9fa"
              :disabled="
                item.mode == 1 ||
                role.owner_school != item.schoolid ||
                identity.identity_status != 1
              "
              @click="download(item.file_url, item.filename)"
              >下载</el-button
            >
            <el-button
              class="el-icon-edit-outline"
              style="border: none; background: #f6f9fa"
              :disabled="
                role.owner_school != item.schoolid ||
                identity.identity_status != 1
              "
              @click="editBtn(item)"
              >编辑</el-button
            >
            <el-button
              class="el-icon-delete"
              style="border: none; background: #f6f9fa"
              :disabled="
                role.owner_school != item.schoolid ||
                identity.identity_status != 1
              "
              @click="delArticleBtn(item)"
              >删除</el-button
            >
          </td>
        </tr>
      </table>

      <!-- 分页 -->
      <el-pagination
        background
        hide-on-single-page
        layout="prev, pager, next"
        @current-change="PageChange"
        :current-page="page"
        :page-size="pageSize"
        :total="count"
      ></el-pagination>
      <!-- 分页 -->

      <!-- 删除资源-->
      <el-dialog
        title="提示"
        center
        :visible.sync="dialogVisible3"
        width="300px"
        style="margin-top: 30vh !important"
      >
        <span>确认删除该资源？</span>
        <br />
        <br />
        <span class="del-span">资源删除后将无法找回！</span>
        <span slot="footer" class="dialog-footer1">
          <el-button
            type="primary"
            @click="(dialogVisible3 = false), delArticleOk()"
            >确 定</el-button
          >
          <el-button @click="dialogVisible3 = false">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 删除资源-->
    </div>
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
import quillConfig from "../common/quill-config.js";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import SparkMD5 from "spark-md5";

export default {
  name: "new_education",
  data() {
    return {
      show_filename: true, // 编辑视频-是否显示文件名
      dialogVisible: false, // 创建框显示
      dialogVisible1: false, // 创建框显示
      dialogVisible2: false, // 编辑框显示
      dialogVisible3: false, // 删除框显示
      dialogVisible4: false, // 上传框显示(添加)
      dialogVisible5: false, // 上传框显示(编辑)
      isSelf: false, // 是否本人
      isDisabled: true, // 是否禁止点击上传按钮
      isVideo: false, // 是否视频模块
      isShow: false, // 是否显示缺省页
      active1: "", // 点击数排序
      active2: "active", // 时间排序
      userid: 1, // 登陆者用户
      uploadUrl: "", // 文件上传地址
      uploadData: "", // 文件上传参数
      sectionValue: "", // 学段,学科(下拉框选中的值)
      sectionList: [], // 该教师下的所有学科
      sectionData: [], // 该教师的学段信息
      page: 1,
      pageSize: 10,
      count: 0,
      type: "", // 类型
      info: [], // 详情
      title: "", // 标题
      content1: "", // 内容(文章添加)
      content2: "", // 内容(文章编辑)
      content3: "", // 内容(视频添加)
      content4: "", // 内容(视频编辑)
      keyword: "", // 关键词
      order_by: 0, // 排序
      open_scope: "1", // 权限(公开)
      mode: "2", //文档模式
      logo: "", // 封面
      file: "", // 视频路径
      file_name: "", // 视频名称
      imageUrl: "", // 封面显示图片
      articleList: [], // 文章列表
      typeData: [], // 类型列表
      typeDataTmp: [], // 类型临时
      typeDataTmpV: [], // 类型临时视频
      typeDataTmpA: [], // 类型临时文章
      yearData: [], // 学年列表
      termData: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "1",
          label: "上学期",
        },
        {
          value: "2",
          label: "下学期",
        },
      ], // 学期列表
      year: "", // 学年
      term: "", // 学期
      section: "", // 学段
      subject: "", // 学科
      role: "", // 获取权限
      identity: "", // 获取身份
      creator_type: 1, // 创建类型 1-教师 2-教研员
      fileList: [],
      maxSize2: 5, // 视频封面限制大小(单位:M)
      extensions2: ["jpg", "jpeg", "png"], // 视频封面允许上传的格式
      fileLimit: 1, // 限制个数
      dialogImageUrl: "",
      activeName: "article",
      quillOption: quillConfig,
      placeholderName: "请选择类型",
      // 分片参数
      // 文档
      FileLimit1: {
        FileMaxSize: 200, // 允许上传的大小 单位(M)
        FileFormat: ["doc", "docx", "xls", "xlsx", "ppt", "pptx", "pdf"], // 允许上传的格式
        FileUnit: "M", // 单位
      },
      // 视频
      FileLimit2: {
        FileMaxSize: 1, // 允许上传的大小 单位(G)
        FileFormat: ["mp4"], // 允许上传的格式
        FileUnit: "G", // 单位
      },
      options: {},
      statusText: {
        success: "上传成功！",
        error: "出错了！",
        uploading: "上传中...",
        paused: "等待中...",
        waiting: "等待中...",
      },
      panelShow: true, // 展示上传panel
      attrs1: {
        accept: ".doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf",
      },
      attrs2: {
        accept: ".mp4",
      },
      websiteSessionInfo: globalApi.gWebsiteSessionInfo,
      loading: false,
    };
  },

  components: {
    quillEditor,
  },
  computed: {
    globalVaranthasInited() {
      return globalApi.gWebsiteSessionInfo.hasInited;
    },
  },
  watch: {
    globalVaranthasInited: function () {
      this.init();
    },
  },
  created() {},

  methods: {
    init() {
      // 获取当前学年/学期
      var date = globalApi.getYearTerm();
      this.year = ""; // 学年
      this.term = ""; // 学期
      this.owner_id = this.$route.query.userid; // 教师空间id

      if (this.owner_id == undefined) {
        this.$router.push("error");
        return false;
      }

      this.getYearList(); // 获取学年
      this.GetSection(); // 获取学段
      this.GetTeacherSection(); // 获取某个教师所教的所有学科
      this.getLoginUserInfo(); // 获取登录信息
    },
    // 获取用的登录数据并存入localStorage
    async getLoginUserInfo() {
      const isLogin = this.websiteSessionInfo.logined;
      if (isLogin) {
        this.userid = this.websiteSessionInfo.userid;
        this.isSelf = this.userid == this.owner_id;
        this.uploadUrl = globalApi.GetWebHost("upload"); // 文件上传地址
        this.uploadData = {
          UserId: this.userid,
          SessionKey: this.websiteSessionInfo.sessionKey,
          OS: 4,
          CheckCode: globalApi.randomString(40),
        };
        this.options = {
          target: globalApi.GetWebHost("upload"), // 上传地址
          testChunks: false,
          singleFile: true, // 启用单个文件上传。上传一个文件后，第二个文件将超过现有文件，第一个文件将被取消。
          chunkSize: "1048576" * 1, //分块大小 单位(M)
          query: {
            //传参
            UserId: this.userid,
            SessionKey: this.websiteSessionInfo.sessionKey,
            OS: 4,
            PluginType: 1,
          },
        };
      }
      this.GetAuth(); // 获取权限
      this.GetIdentity(); // 获取身份
      this.GetArticleTypes(); // 获取分类列表
    },

    // 删除弹窗提示
    delMsg(school) {
      this.$message({
        showClose: true,
        message: "请联系" + school + "管理员屏蔽后再删除。",
      });
    },

    // 分页导航
    PageChange(val) {
      this.page = val;
      this.SearchArticle(); // 获取资源文章
    },

    // 改变编辑状态
    changeEdit() {
      this.isDisabled = false;
    },

    handleClick() {
      this.page = 1;
      if (this.activeName == "article") {
        this.type = "";
      } else {
        this.type = this.activeName;
      }

      this.SearchArticle();
    },

    // 切换类型
    changeType(i) {
      this.page = 1;
      this.type = i == "article" || i == "video" ? 0 : i.id;
      this.isVideo = i == "video" || i.item_type == 2 ? true : false;
      this.mode = this.isVideo || i == "video" ? 3 : 1;
      this.SearchArticle();
    },

    // 切换学段
    changeSection(i) {
      this.page = 1;
      this.section = i == undefined ? "" : i;
      this.SearchArticle();
    },

    // 排序搜索
    changeActive(val) {
      this.page = 1;
      if (val == 1) {
        this.active1 = "active";
        this.active2 = "";
      } else {
        this.active1 = "";
        this.active2 = "active";
      }
      this.order_by = val;
      this.SearchArticle(); // 获取资源文章
    },

    // 学年搜索
    // type = 1 学年搜索
    // type = 2 学期搜索
    changeYear(type) {
      if (this.year == 0) {
        this.term = "0";
        if (type == 2) {
          this.$message.error("请先选择学年!");
          return false;
        }
      }
      this.page = 1;
      this.SearchArticle();
    },

    // 筛选搜索
    search() {
      this.page = 1;
      this.SearchArticle();
    },

    // 内容模式切换
    changeMode() {
      this.content1 = "";
      this.content2 = "";
      this.file = "";
      this.fileList = [];
    },

    // 获取权限
    async GetAuth() {
      const data = {
        s: "Common.Auth.getAuth",
        operator_id: this.userid, // 登陆者id
        user_id: this.owner_id, // 空间id
      };

      const res = await globalApi.post(data);
      if (res.data.ret != 200) {
        return false;
      }
      this.role = res.data.data;
    },

    // 获取身份
    async GetIdentity() {
      const data = {
        s: "Common.Auth.getIdentity",
        user_id: this.userid, // 登陆者id
      };

      const res = await globalApi.post(data);
      if (res.data.ret != 200) {
        return false;
      }
      this.identity = res.data.data;
    },

    // 获取学年接口
    async getYearList() {
      const data = {
        s: "WebSchoolSpace.Common.getYearList",
      };

      const res = await globalApi.post(data);
      if (res.data.ret != 200) {
        return false;
      }

      this.yearData = res.data.data;
    },

    // 获取学段列表
    async GetSection() {
      const data = {
        s: "WebTeacherSpace.NewEdu.GetSection",
        teacher_id: this.owner_id, // 教师id
      };

      const res = await globalApi.post(data);
      if (res.data.ret != 200) {
        this.isShow = true;

        return false;
      }

      this.sectionData = res.data.data;
    },

    // 获取分类列表
    async GetArticleTypes() {
      const data = {
        s: "WebTeacherSpace.NewEdu.GetArticleTypes",
        teacher_id: this.owner_id, // 教师id
        type_of: 8,
      };

      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200 || response != 1) {
        return false;
      }
      const list = res.data.data;
      this.typeDataTmp = list["list"];
      this.typeDataTmpA = [];
      this.typeDataTmpV = [];
      this.typeDataTmp.forEach((element) => {
        if (element.item_type == 1) {
          this.typeDataTmpA.push(element);
        } else {
          this.typeDataTmpV.push(element);
        }
      });
      let tmptype = this.isVideo ? this.typeDataTmpV : this.typeDataTmpA;
      this.typeData = JSON.parse(JSON.stringify(tmptype));
      this.SearchArticle(); // 获取资源列表
    },

    // 获取某个教师所教的所有学科
    async GetTeacherSection() {
      const data = {
        s: "WebTeacherSpace.TeachingArticle.GetTeacherSection",
        userid: this.owner_id, // 教师id
      };
      const res = await globalApi.post(data);
      if (res.data.ret != 200) {
        return false;
      }

      this.sectionList = res.data.data;
    },

    // 获取某条资源文章的内容
    async GetArticleInfo() {
      const data = {
        s: "WebTeacherSpace.NewEdu.GetArticleInfo",
        operator_id: this.userid, // 登录id
        article_id: this.article_id, // 文章id
      };
      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200 || response != 1) {
        return false;
      }
      if (response == 1) {
        const info = res.data.data.info;
        this.info = info;
        this.title = info.title;
        this.content2 = info.content; // 内容
        this.content4 = info.content; // 内容
        this.section = String(info.section);
        this.sectionValue = info.section + "," + info.subjectid;
        this.open_scope = String(info.open_scope); // 权限
        this.fileList = [{ name: info.filename, url: info.file_resid }];
        this.logo = info.logo_resid;
        this.file = info.file_resid;
        this.file_name = info.filename;
        this.imageUrl = info.imageUrl;
        this.mode = String(info.mode);
      } else {
        this.$message.error("server error");
      }
    },

    // 获取资源列表
    async SearchArticle() {
      this.loading = true;
      document.documentElement.scrollTop = 0;
      var approve_status = this.isSelf ? 0 : 2; // 0=返回所有 1=返回待审批的数据 2=已审批通过的数据
      var delete_status = this.isSelf ? 1 : 0; // 1=返回所有 0=只显示未删除的
      var data = {
        s: "WebTeacherSpace.NewEdu.SearchArticle",
        operator_id: this.userid, // 登录id
        teacher_id: this.owner_id, // 教师空间id
        page: this.page,
        category: 1,
        page_size: this.pageSize,
        type: this.type, // 类型
        section: this.section, // 学段
        subject: this.subject, // 学科
        order_by: this.order_by, // 学科
        keyword: this.keyword, // 关键词
        year: this.year, // 学年
        term: this.term, // 学期
        approve_status: approve_status, // 0=返回所有 1=返回待审批的数据 2=已审批通过的数据
        delete_status: delete_status, // 1=返回所有 0=只显示未删除的
        mode: this.mode, // 1/2 文章 3 视频
        creator_type: this.creator_type, // 创建者类型 1-教师 2-教研员
      };

      const res = await globalApi.post(data);
      this.loading = false;
      const response = res.data.data.result;
      if (res.data.ret != 200 || response != 1) {
        return false;
      }
      this.count = res.data.data.recordcount;
      this.articleList = res.data.data.list;
      this.count == 0 ? (this.isShow = true) : (this.isShow = false);
    },

    // 新增文章接口
    async CreateArticle() {
      const data = {
        s: "WebTeacherSpace.NewEdu.CreateArticle",
        operator_id: this.userid, // 操作者id
        teacher_id: this.owner_id, // 教师空间id
        type: this.type, // 类型
        category: 1,
        section: this.section, // 学段id
        subject: this.subject, // 科目id
        title: this.title, // 标题
        content: this.content1, // 内容
        logo: this.logo, // 视频封面
        file: this.file, // 视频路径
        file_name: this.file_name, // 视频名称
        mode: this.mode, // 1-文章模式 2写作模式 3视频模式
        open_scope: this.open_scope, // 权限
        creator_type: this.creator_type, // 创建者类型 1-教师 2-教研员
      };

      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200 || response != 1) {
        return false;
      }
      if (response == 1) {
        this.dialogVisible1 = false;
        this.dialogVisible4 = false;
        this.$message.success("添加成功!");
        this.clear(); // 清除数据
        this.SearchArticle(); // 获取资源列表
      } else {
        this.$message.error("添加失败!");
      }
    },

    // 编辑文章接口
    async ModifyArticle() {
      const data = {
        s: "WebTeacherSpace.NewEdu.ModifyArticle",
        operator_id: this.userid, // 操作者id
        teacher_id: this.owner_id, // 教师空间id
        article_id: this.article_id, // 文章id
        section: this.section, // 学段id
        subject: this.subject, // 科目id
        title: this.title, // 标题
        type: this.type,
        content: this.content2, // 内容
        logo: this.logo, // 视频封面
        file: this.file, // 视频路径
        file_name: this.file_name, // 视频名称
        mode: this.mode, // 1-文章模式 2写作模式 3视频模式
        open_scope: this.open_scope, // 权限
      };

      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200 || response != 1) {
        return false;
      }
      if (response == 1) {
        this.dialogVisible2 = false;
        this.dialogVisible5 = false;
        this.$message.success("编辑成功!");
        this.clear(); // 清除数据
        this.SearchArticle(); // 获取资源列表
      } else {
        this.$message.error("编辑失败!");
      }
    },

    // 删除文章接口
    async DeleteArticle() {
      const data = {
        s: "WebTeacherSpace.NewEdu.DeleteArticle",
        operator_id: this.userid,
        article_id: this.article_id, // 文章id
      };
      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200 || response != 1) {
        return false;
      }
      if (response == 1) {
        this.dialogVisible3 = false;
        this.$message.success("删除成功!");
        this.SearchArticle(); // 获取资源列表
      } else {
        this.$message.error("删除失败!");
      }
    },

    // 点击发布按钮
    async addBtn() {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      this.isDisabled = false;
      this.panelShow = false;
      if (this.activeName == "article" || this.activeName == "video") {
        this.type = "";
        this.placeholderName = "请选择类型";
      }

      this.clear();
      if (this.isVideo) {
        this.dialogVisible4 = true;
      } else {
        this.dialogVisible1 = true;
      }
    },

    // 发布确定按钮(文章)
    // type:1 发布
    // type:2 编辑
    async submitOk1(type) {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      if (this.title == false) {
        this.$message.error("标题不能为空!");
        return false;
      }
      if (this.section == false) {
        this.$message.error("请选择学段!");
        return false;
      }
      if (this.type == false) {
        this.$message.error("请选择类型!");
        return false;
      }
      if (this.mode == 1) {
        if (this.content1 == false && type == 1) {
          this.$message.error("内容不能为空!");
          return false;
        }
        if (this.content2 == false && type == 2) {
          this.$message.error("内容不能为空!");
          return false;
        }
      } else {
        if (this.file == false && type == 1) {
          this.$message.error("请上传文件!");
          return false;
        }
      }
      this.isDisabled = true;
      if (type == 1) {
        this.CreateArticle(); // 发布
      } else {
        this.ModifyArticle(); // 编辑
      }
      this.activeName = this.type.toString();
    },

    // 发布确定按钮(视频)
    // type:1 发布
    // type:2 编辑
    async submitOk2(type) {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      if (this.title == false) {
        this.$message.error("标题不能为空!");
        return false;
      }
      if (this.section == false) {
        this.$message.error("请选择学段!");
        return false;
      }
      if (this.type == false) {
        this.$message.error("请选择文章类型!");
        return false;
      }
      if (this.file == false) {
        this.$message.error("请上传视频文件!");
        return false;
      }
      this.isDisabled = true;
      if (type == 1) {
        this.content1 = this.content3;
        this.CreateArticle(); // 发布
      } else {
        this.content2 = this.content4;
        this.ModifyArticle(); // 编辑
      }
      this.activeName = this.type.toString();
    },

    // 点击编辑按钮
    async editBtn(val) {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      this.isDisabled = true;
      this.show_filename = true; // 显示文件名
      this.clear();
      var identity_status = this.identity.identity_status;
      var school_id = this.identity.school_id;
      if (school_id == val.schoolid && identity_status == 1) {
        if (val.mode == 1 || val.mode == 2) {
          this.dialogVisible2 = true;
        } else {
          this.dialogVisible5 = true;
        }
        this.article_id = val.id;
        this.typeDataTmp.forEach((element) => {
          if (element.id == val.type) {
            this.type = element.id;
            this.placeholderName = element.name;
          }
        });
        this.GetArticleInfo(); // 获取某条资源文章的内容
      } else {
        return false;
      }
    },

    // 跳转详情
    async toInfo(val) {
      var open_scope = val.open_scope;
      if (open_scope != 1) {
        const is_login = await globalApi.CheckLoginUserStatus(this);
        if (!is_login) {
          this.$message.error("对不起,你没有该权限!");
          return;
        }
      }
      if (
        open_scope == 1 ||
        this.identity.school_id == val.schoolid ||
        this.isSelf
      ) {
        globalApi.jumpPath(2, "school_newedu_info", "id=" + val.id);
      } else if (!globalApi.IsLogIned() && open_scope != 1) {
        let fromurl = encodeURIComponent(location.href);
        location.href = globalApi.GetWebHost("login") + '?fromurl=' + fromurl;
        return false;
      } else {
        this.$message.error("对不起,你没有该权限!");
      }
    },

    // 清除数据
    clear() {
      this.mode = this.isVideo ? "3" : "2";
      this.title = "";
      this.sectionValue = "";
      this.content1 = "";
      this.content2 = "";
      this.open_scope = "1";
      this.section = "";
      this.subject = "";
      this.content3 = "";
      this.fileList = [];
      this.file = "";
      this.file_name = "";
      this.logo = "";
      this.panelShow = false;
      this.imageUrl = "";
      if (this.$refs.upload != undefined) {
        this.$refs.upload.clearFiles();
      }
      if (this.$refs.upload1 != undefined) {
        for (let key in this.$refs.upload1.files) {
          this.$refs.upload1.files[key].cancel();
        }
      }
      if (this.$refs.upload2 != undefined) {
        for (let key in this.$refs.upload2.files) {
          this.$refs.upload2.files[key].cancel();
        }
      }
    },

    // 删除按钮
    async delArticleBtn(val) {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      if (
        val.schoolid !== this.identity.school_id &&
        val.approve_status == 2 &&
        val.delete_by == 0
      ) {
        this.delMsg(val.school_name);
        return false;
      } else {
        this.dialogVisible3 = true;
        this.article_id = val.id; // 文章id
      }
    },

    // 删除文章确定
    async delArticleOk() {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      this.DeleteArticle();
    },

    // 关闭添加文章弹窗操作
    close1() {
      this.dialogVisible1 = false;
      this.clear();
    },

    // 关闭编辑文章弹窗操作
    close2() {
      this.dialogVisible2 = false;
      this.clear();
    },

    // 关闭添加视频弹窗操作
    close4() {
      this.dialogVisible4 = false;
      this.clear();
    },

    // 关闭编辑视频弹窗操作
    close5() {
      this.dialogVisible5 = false;
      this.clear();
    },

    // 下载文件
    download(file_url, file_name) {
      window.location =
        globalApi.GetWebHost("private-api") +
        "/?s=WebTeacherSpace.TeachingArticle.download" +
        "&file_url=" +
        file_url +
        "&file_name=" +
        file_name;
    },

    // **上传相关** ----------------------
    // 上传成功(封面)
    onSuccess2(response, file, fileList) {
      if (response.Result) {
        this.isDisabled = false; // 允许点击上传
        this.logo = response.Data.Original; // 视频封面
      } else {
        if (response.ErrCode != 4) {
          this.$message.error(response.Errstr);
        }
      }
    },

    // 上传文件之前的钩子(封面)
    beforeUpload2(file) {
      this.uploadData.CheckCode = globalApi.randomString(40);
      if (file["size"] >= this.maxSize2 * 1024 * 1024) {
        this.$message.warning(
          file["name"] + " 文件大小不能大于" + this.maxSize2 + "M!"
        );
        return false;
      } else {
        this.imageUrl = "";
        return this.checkExtensions(file.name, this.extensions2);
      }
    },

    // 文件上传时的钩子(封面)
    onProgress2(event, file, fileList) {},

    // 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用(封面)
    onChange2(file, fileList) {},

    // 文件列表移除文件时的钩子(封面)
    onRemove2(file, fileList) {
      this.logo = "";
    },

    // 文件超过个数提示
    onExceed(files, fileList) {
      this.$message.warning("最多上传" + this.fileLimit + "个文件");
    },

    // 封面图片渲染
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    // @分片相关--------

    // 检查文件格式
    // fileName 文件名称
    // extensions 允许上传的格式
    checkExtensions(fileName, extensions) {
      var format = fileName.split(".").pop().toLowerCase(); // 用户上传的文件格式

      // 把允许上传文件格式的数组转为字符串
      var s = extensions.join(",");
      var exp = new RegExp(format);
      if (!exp.test(extensions)) {
        this.$message.warning("请上传 " + s + " 的格式!");
        return false;
      }
      return true;
    },

    // 检查文件大小
    checkSize(fileSize) {
      var isSize;
      if (this.isVideo) {
        var FileLimit = this.FileLimit2;
        isSize = fileSize / 1024 / 1024 / 1024 < this.FileLimit2.FileMaxSize; // 单位(G)
      } else {
        var FileLimit = this.FileLimit1;
        isSize = fileSize / 1024 / 1024 < this.FileLimit1.FileMaxSize; // 单位(M)
      }
      if (!isSize) {
        this.$message.warning(
          " 文件大小不能大于" + FileLimit.FileMaxSize + FileLimit.FileUnit + "!"
        );
        return false;
      }
      return true;
    },

    // 添加一个文件时触发
    async filesAdded(file) {
      file.uniqueIdentifier = globalApi.randomString(32); //把md5值作为文件的识别码
      let that = this;
      //检验视频编码格式
      MediaInfo({ format: "object" }, (mediainfo) => {
        globalApi.onChangeFile(mediainfo, file, that);
      });
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      if (this.isVideo) {
        var FileLimit = this.FileLimit2;
      } else {
        var FileLimit = this.FileLimit1;
      }
      const isFormat = this.checkExtensions(file.name, FileLimit.FileFormat); // 文件格式判断
      if (!isFormat) {
        file.ignored = true; // 过滤文件
        file.cancel(); // 停止上传
        return false;
      }
      // 文件大小判断
      const isSize = this.checkSize(file.size);
      if (!isSize) {
        file.ignored = true; // 过滤文件
        file.cancel(); // 停止上传
        return false;
      } else {
        this.panelShow = true; // 展示上传panel
        this.show_filename = false; // 不显示文件名
        this.computeMD5(file); // md5验证
      }
    },

    // 文件上传中触发
    fileProgress(rootFile, file, chunk) {
      // 判断上传是否在上传
      if (file.isUploading()) {
        this.show_filename = false; // 不显示文件名
        this.isDisabled = true; // 禁止点击上传
      }
    },

    // 文件移除触发
    fileRemoved(file) {
      this.file = "";
      this.file_name = "";
      this.isDisabled = true; // 不允许点击
    },

    // 上传成功后触发
    onFileSuccess: function (rootFile, file, response, chunk) {
      var response = JSON.parse(response);
      if (response.Result) {
        this.isDisabled = false; // 允许点击上传
        this.file = response.Data.Original; // 视频路径
        this.file_name = response.Data.Realname; // 视频路径
      } else {
        if (response.ErrCode != 4) {
          this.$message.error(response.Errstr);
        }
      }
    },

    // 上传错误触发
    onFileError(rootFile, file, response, chunk) {
      this.$message({
        message: "上传失败,请重新上传!",
        type: "error",
      });
    },

    // 校验MD5
    computeMD5(file) {
      let fileReader = new FileReader();
      let time = new Date().getTime();
      let blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
      let currentChunk = 0;
      const chunkSize = 10 * 1024 * 1000;
      let chunks = Math.ceil(file.size / chunkSize);
      let spark = new SparkMD5.ArrayBuffer();
      file.pause();

      loadNext();

      fileReader.onload = (e) => {
        spark.append(e.target.result);
        if (currentChunk < chunks) {
          currentChunk++;
          loadNext();
          this.$nextTick(() => {});
        } else {
          let md5 = spark.end();
          this.computeMD5Success(md5, file);
        }
      };
      fileReader.onerror = function () {
        this.error(`文件${file.name}读取出错，请检查该文件`);
        file.cancel();
      };

      function loadNext() {
        let start = currentChunk * chunkSize;
        let end =
          start + chunkSize >= file.size ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
      }
    },

    // 验证成功
    computeMD5Success(md5, file) {
      // file.uniqueIdentifier = globalApi.randomString(32); //把md5值作为文件的识别码
      file.resume(); //开始上传
    },
  },
};
</script>
<style>
</style>
<style lang="scss" scoped>
@import url("../../assets/css/quill.css");
html {
  width: 100%;
  font-family: Microsoft YaHei, Tahoma, Helvetica, Arial, sans-serif;
  background: #f6f9fa;
}
.clearfix {
  clear: both;
  overflow: hidden;
  zoom: 1;
}
.main {
  width: 1200px;
  padding-top: 20px;
  margin: 0px auto;
  min-height: 800px;
  background: #f6f9fa;
  .add_article_box {
    .el-dialog {
      .el-dialog__header {
        padding: 0;
        // text-align: center;
      }
      .p1 {
        margin-bottom: 10px;
        .star {
          color: red;
        }
        .tips {
          margin-left: 16px;
          font-size: 12px;
          color: #99a8b4;
        }
      }
      .p2 {
        margin-bottom: 30px;
        .el-input {
          width: 500px;
        }
      }
      #p1 {
        margin-top: 30px;
      }
      .div2 {
        margin-top: 10px;
      }
    }
    .el-select {
      display: inline-block;
      position: relative;
      margin: 0 20px 20px 0;
      width: 150px;
    }
    .input_item {
      width: 400px;
      margin: 0 10px 10px 0;
    }
  }
}
.grade {
  width: 100%;
  height: 48px;
  line-height: 54px;
  box-shadow: 0px 1px 0px 0px rgba(233, 233, 233, 1);
  margin-bottom: 40px;
  .active {
    color: #0088ff;
  }
  #sel {
    margin: 0;
  }
  span {
    float: left;
    margin-left: 20px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    cursor: pointer;
  }
  .demonstration {
    float: right;
  }
  el-cascader {
    float: right;
  }
}
.line {
  box-shadow: 0px 1px 0px 0px rgba(233, 233, 233, 1);
  span {
    cursor: pointer;
    margin-left: 20px;
  }
}
.top-operation {
  width: 100%;
  height: 48px;
  line-height: 48px;
  .active {
    color: #0088ff;
  }
  span {
    float: right;
    // margin-left: 20px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }
}
.nav {
  span {
    float: left;
    margin-right: 20px;
    cursor: pointer;
  }
}
.group {
  line-height: 48px;
  background-color: aqua;
  width: 100%;
  height: 48px;
  span {
    margin-left: 17px;
    font-family: "MicrosoftYaHei";
    color: #333333;
    font-size: 14px;
    font-weight: Regular;
  }
}
.line {
  margin-bottom: 35px;
}
.title {
  margin-left: 10px;
  font-family: "MicrosoftYaHei-Bold";
  font-size: 14px;
  font-weight: Bold;
  color: #333333;
}
.information {
  font-family: "MicrosoftYaHei";
  font-size: 14px;
  color: #666666;
  font-weight: Regular;
  cursor: pointer;
}

.el-pagination {
  text-align: center;
  padding: 20px 0 40px 0;
}
</style>
<style lang="scss" scoped>
.el-dialog__body {
  padding: 0px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.el-dialog__footer {
  padding: 0px 20px 15px 20px;
  text-align: left;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.none {
  height: 480px;
  line-height: 620px;
  text-align: center;
  background: url(../../assets/img/home_img_2.png) no-repeat center 100px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  position: absolute;
  width: 1180px;
}
.top-type .el-select {
  width: 120px;
  float: right;
  margin-left: 20px;
}

//添加视频弹框
.add_video_box {
  .el-dialog__body {
    padding: 20px 20px 0px;
  }
  .form_item {
    margin-bottom: 15px;
  }
  .dialog-footer {
    position: relative;
    top: -25px;
    float: left;
  }
  .dialog_content {
    margin: 0;
    .form_item {
      .title_text {
        // text-align: right;
        width: 400px;
        margin-right: 10px;
        font-size: 14px;
        color: #666666;
        margin: 5px 10px 15px 0;
        .advice {
          font-size: 12px;
          color: #999999;
        }
      }
      .el-select {
        display: inline-block;
        position: relative;
        margin: 0 20px 20px 0;
        width: 150px;
      }
      .input_item {
        width: 400px;
        margin: 0 10px 10px 0;
      }
      .mr-b20 {
        margin-bottom: 20px;
      }
    }
  }
}
.block .el-select {
  float: right;
  margin: 0px 0 0 20px;
}
.el-input {
  position: relative;
  font-size: 14px;
  display: inline-block;
  width: 120px;
}
</style>
<style lang="scss" scoped>
table {
  width: 1200px;
  text-align: center;
  tr {
    border-bottom: 1px solid rgba(233, 233, 233, 1);
    height: 48px;
    line-height: 48px;
  }
  .first-tr {
    background: #e4e5e8;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);

    .td1 {
      text-align: left;
      padding-left: 50px;
    }
  }
  .second-tr {
    font-family: Microsoft YaHei;
    height: 60px;
    line-height: 60px;
    .limit {
      max-width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .td-1 {
      p {
        font-size: 14px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        padding-left: 50px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 20rem;
      }
    }
    .td-2 {
      font-size: 14px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
    .td-3 {
      span {
        cursor: pointer;
      }
    }
  }
}
.el-icon-delete:before,
.el-icon-edit-outline:before {
  padding: 5px;
  margin-left: 8px;
}
</style>
<style lang="scss">
.el-dialog__header {
  padding: 20px 20px 10px;
  text-align: center;
}
.el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 25px 25px 30px;
  text-align: center;
}
</style>
<style lang="scss">
.ql-editor {
  min-height: 200px;
  max-height: 250px;
}
.el-dialog {
  margin-top: 5vh !important;
}
</style>


<style >
.el-loading-spinner {
  font-size: 50px;
  padding: 20px 0;
}
.el-loading-spinner .el-loading-text {
  font-size: 24px;
  color: white;
}
.el-loading-spinner i {
  color: white;
  margin-bottom: 20px;
}
.td-2 .el-button--small,
.el-button--small.is-round {
  padding: 9px 0px;
}
</style>
<style>
.uploader-example .uploader-btn {
  margin-right: 4px;
}
.uploader-btn:hover {
  background-color: #409eff !important;
}
.uploader-example .uploader-list {
  max-height: 440px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto;
}
.uploader-file-actions .uploader-file-pause {
  display: none !important;
}
.uploader-file-actions .uploader-file-resume {
  display: none !important;
}
.uploader-file-actions .uploader-file-retry {
  display: none !important;
}

.uploader-file-status span i {
  display: none !important;
}
</style>
<style>
.el-tabs__nav-wrap::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
  background-color: #e4e7ed;
  z-index: 1;
}
.el-tabs__active-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 0px;
  background-color: #409eff;
  z-index: 1;
}
</style>
<style lang="scss">
.uploader-example {
  .uploader-drop {
    padding: 0px;
    border: 0px dashed #ccc;
    background-color: #ffffff;
  }
  .uploader-btn {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    white-space: nowrap;
    cursor: pointer;
    border: 1px solid #dcdfe6;
    text-align: center;
    box-sizing: border-box;
    padding: 7px 14px;
    font-size: 14px;
    border-radius: 4px;
  }
  .uploader-list {
    .uploader-file {
      border-bottom: 0px solid #cdcdcd;
    }
    .uploader-file-name {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 19px;
      color: rgba(33, 33, 33, 1);
      padding: 10px 0;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 15rem;
    }
    .uploader-file-size {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 19px;
      color: rgba(33, 33, 33, 1);
      padding: 10px 0;
    }
    .uploader-file-actions {
      width: 10%;
      position: relative;
      top: -5px;
    }
    .uploader-file-status {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 19px;
      color: rgba(33, 33, 33, 1);
      padding: 10px 0;
      color: #17c46d;
    }
    .uploader-file-icon {
      margin-top: -3px;
      margin-right: 8px;
    }
    .uploader-file-progress {
      background: #ffffff;
    }
  }
}
</style>